/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class SubsidyGrouping extends Ce {
    constructor() {
        super();
        this.baseUrl += '/subsidyGrouping';
    }

    findSubsidyGroupingListWithStat({
        subsidyGroupingName,
        subsidyGroupingSn,
        certCatId,
        certExamType,
        schoolOrgId,
        subsidyGroupingStatus,
        subsidyGroupingDesc,
        subsidyApplyEndTime,
        insertTime,
        verticalGroupingName,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let subsidyApplyEndTimeBegin = null;
        let subsidyApplyEndTimeEnd = null;
        if (subsidyApplyEndTime != null && subsidyApplyEndTime.length === 2) {
            [subsidyApplyEndTimeBegin, subsidyApplyEndTimeEnd] = subsidyApplyEndTime;
        }
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        return super.get('/findSubsidyGroupingListWithStat', {
            subsidyGroupingName,
            subsidyGroupingSn,
            certCatId,
            certExamType,
            schoolOrgId,
            subsidyGroupingStatus,
            subsidyGroupingDesc,
            subsidyApplyEndTimeBegin,
            subsidyApplyEndTimeEnd,
            insertTimeBegin,
            insertTimeEnd,
            verticalGroupingName,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id } = {}) {
        return super.get('/get', { id });
    }

    save({
        id,
        subsidyGroupingName,
        subsidyGroupingSn,
        certExamId,
        verticalGroupingId,
        examinationTime,
        subsidyApplyEndTime,
        subsidyGroupingDesc,
    } = {}) {
        return super.post('/save', {
            id,
            subsidyGroupingName,
            subsidyGroupingSn,
            certExamId,
            verticalGroupingId,
            examinationTime,
            subsidyApplyEndTime,
            subsidyGroupingDesc,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    removeDetail({ subsidyGroupingId, ids }) {
        return super.post('/removeDetail', { subsidyGroupingId, ids });
    }

    detailStatus({ subsidyGroupingDetailId, isAvailable }) {
        return super.post('/detailStatus', { subsidyGroupingDetailId, isAvailable });
    }

    changeSubsidyGroupingStatus({ ids, subsidyGroupingStatus } = {}) {
        return super.post('/changeSubsidyGroupingStatus', {
            ids,
            subsidyGroupingStatus,
        });
    }

    editDetailRemarks({ subsidyGroupingDetailId, remarks } = {}) {
        return super.post('/editDetailRemarks', {
            subsidyGroupingDetailId,
            remarks,
        });
    }

    synchronizeApplyMaterialsScan({
        subsidyGroupingId,
        idCardNo,
        front,
        firstClaim,
        effectTime,
        expireTime,
        reviewTime,
    }) {
        return super.post(
            '/synchronizeApplyMaterialsScan',
            {
                subsidyGroupingId,
                idCardNo,
                front,
                firstClaim,
                effectTime,
                expireTime,
                reviewTime,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }
}

export default new SubsidyGrouping();
export { SubsidyGrouping };
